import styled from "@emotion/styled";

export const MypageLayoutContainer = styled.div`
    position: relative;
`;

export const MypageContentLayout = styled.div`
    position: absolute;
    top: 0;
    display: flex;
    max-height: 200vh;
    flex-direction: column;
    width: 100%;
    z-index: 1;
`;
